
import { Component, Vue, Prop } from 'vue-property-decorator'
import ls from '@/ls'

@Component
export default class SaveButton extends Vue {
  @Prop({ default: 'Opslaan' }) saveText!: string
  @Prop({ default: 'Opslaan & Terug' }) saveAndReturnText!: string
  @Prop({ default: false }) loading!: boolean
  @Prop({ default: false }) disabled!: boolean
  selectedOption = ls.get('save-option') || 1

  setSelectedOption (option: number): void {
    this.selectedOption = option
    ls.set('save-option', option)
    this.handleClick()
  }

  handleClick (): void {
    if (this.selectedOption === 1) {
      this.$emit('save')
    } else if (this.selectedOption === 2) {
      this.$emit('save-and-return')
    }
  }
}
